import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'spk-tabs',
  templateUrl: './spk-tabs.component.html',
  styleUrls: ['./spk-tabs.component.scss']
})
export class SpkTabsComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
